import NestedForm from '/node_modules/stimulus-rails-nested-form/dist/stimulus-rails-nested-form.umd.js'
import axios from "axios";
import notify from "../../packs/notify";
import LoadingSpinner from "../../packs/loading_spinner";
import i18next from 'i18next';

const specimenTypeDescSelector = "[data-portal--submission-specimen-target='specimenTypeDescription']"
const itemSelector = "[data-portal--submission-specimen-target='item']"

export default class extends NestedForm {

  static targets = [
    "specimenCard", 
    "addSpecimen",
    "specimenTypeDescription",
    "autocomplete",
    "childIndex",
    "item",
    "autoCompleteInput",
    "autoCompleteHidden",
    "name"
  ]

  static values = {
    setupSpecimenCount: { type: Number, default: 0 },
    setupAnimalCount: { type: Number, default: 0 },
    specimensDbRecordSize: { type: Number, default: 0 },
    animalsDbRecordSize: { type: Number, default: 0 },    
    currentLocale: {type: String, default: "en"},
    initialAnimalTagTypesNum: String,
    initialAnimalTagTypesNumsList: Array,
    needGenerateAnimalIds: String,
    needGenerateAnimalIdsList: Array,
    amountOfSubmissionType: {type: String, default: "multiple" },
    setupIncrementalName: { type: String,  default: "" },
    maxCountForCardDesign: { type: Number, default: 2 },
  };

  connect() {
    super.wrapperSelectorValue = '.nested-form-specimen-wrapper'
    super.connect()
    this.displayToggleSpecimenHeader()
    this.figureOutAmountOfSubmissionType()
    this.initialSetAnimalTagsParams()
    this.generateSpecimenProcess()
    this.boundLoadSpecimenDescTypes = this.loadSpecimenDescTypes.bind(this)
    this.boundLoadSpecimenDescTypesFromCopyDown = this.loadSpecimenDescTypesFromCopyDown.bind(this)
    this.boundCleanSpecimenTypeDescTargets = this.cleanSpecimenTypeDescTargets.bind(this)

    document.addEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundLoadSpecimenDescTypes)
    document.addEventListener("copy-down:triggerAutocompleteChangeEventFromCopyDown", this.loadSpecimenDescTypesFromCopyDown)
    document.addEventListener("autocomplete:clearExtraDataAfterClickClearIcon", this.boundCleanSpecimenTypeDescTargets)
    if (this.setupSpecimenCountValue == 0){
      this.refreshIndexValue()
    }
    setTimeout(() => this.addIdForFlatpickerHidden(), 500)
  }

  disconnect(){
    document.removeEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundLoadSpecimenDescTypes)
    document.removeEventListener("autocomplete:clearExtraDataAfterClickClearIcon", this.boundCleanSpecimenTypeDescTargets)
  }

  cleanSpecimenTypeDescTargets(e){
    if (!this.accurateTarget(e)) return
    const target = document.querySelector(`${specimenTypeDescSelector}[data-id="${e.target.dataset.id}"]`)
    if (target) target.innerHTML = "";
  }

  accurateTarget(e){
    let dataset = e.target.dataset
    return (dataset.id.indexOf('specimen') > -1) && (e.target.dataset.inputName == "specimen_type")
  }

  loadSpecimenDescTypes(e){
    if (!this.accurateTarget(e)){
      return 
    }

    let id = e.detail.event.detail.value
    let url = "/specimen_type_descriptions/ajax_search?specimen_type_id=" + parseInt(id)
    axios({
      url: url, 
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then(res => {
      this.updateSpecimenTypeDescDropdown(res.data, e);
    })
  }

  // We need to start refresh specimenDescType, when we change a autocomplete using by copyDown controller.
  // It is getting an error if we try to call another function from here.
  loadSpecimenDescTypesFromCopyDown(e){
    const id = e.detail.item.value
    const datasetId = e.detail.item.dataset.id
    const currentOrderNumber = e.detail.item.closest(itemSelector).dataset.ordernumber
    let data = ""
    const url = "/specimen_type_descriptions/ajax_search?specimen_type_id=" + parseInt(id)
    axios({
      url: url,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then(res => {
      data = res.data
      let target = document.querySelector(`${specimenTypeDescSelector}[data-id="${datasetId}"]`)
      if (target) target.innerHTML = "";
      generateOptionForSpecimenTypeDesc(data, target)
      return Promise.resolve("Triggered API and completed")
    }).then(res => {
      refreshSpecimenTypeDesc(currentOrderNumber, data)
    })

  }

  updateSpecimenTypeDescDropdown(data, e) {
    let target = document.querySelector(`${specimenTypeDescSelector}[data-id="${e.target.dataset.id}"]`)
    if (target) target.innerHTML = "";   

    // Add a empty option
    const option = document.createElement("option");
    option.value = "";
    option.innerHTML = ""
    if (target) target.appendChild(option);
    data.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.id;
      option.innerHTML = item.value
      target.appendChild(option);
    });
  }

  generateSpecimenProcess(){
    LoadingSpinner("show")
    this.generateSpecimens()
    .then(res => {
      if (this.isMultipleAnimal() || this.setupSpecimenCountValue > this.maxCountForCardDesignValue ){
        this.addSetupIncrementalNameByOneBy()
        return this.generateSpecimenWithWithoutAnimalIds()
      } else {
        return Promise.resolve("")
      }
    })
    .then(res =>{
      this.refreshIndexValue()
      LoadingSpinner("hide")
    })
  }

  // if we added a new animal for existing records we need to make sure added a new specimen
  async generateSpecimenWithWithoutAnimalIds(){
    const listIds = this.needGenerateAnimalIdsListValue
    for (let i = 0; i < listIds.length; i++) {
      const tagObject = listIds[i];
      const tagNum = tagObject.num
      const animalId = tagObject.animal_id
      if (tagNum && animalId){
        await(this.startToAdd()).then(res => { 
          const inputItem = this.getLastTarget(this.autoCompleteInputTargets)
          const hiddenItem = this.getLastTarget(this.autoCompleteHiddenTargets)
          if (inputItem) inputItem.value = tagNum
          if (hiddenItem) hiddenItem.value = animalId
        })
      }
    }
  }

  async generateSpecimens(){
    let targetIdx = 0
    let reference = this.animalsDbRecordSizeValue;
    if (this.isSingleAnimal()) reference = 1

    for (let i = 0; i < reference; i++) {
      for (let j = 0; j < this.setupSpecimenCountValue; j++) {
        await(this.startToAdd()).then(res => {
          if (reference > 1) this.putAnimalTagTypesEachSpecimen(targetIdx, i)
          targetIdx++
        })
      }
    }
  }

  putAnimalTagTypesEachSpecimen(targetIdx, i){
    const tagTypeObject =  this.initialAnimalTagTypesNumsListValue[i]
    const tagNum = tagTypeObject.num
    const animalId = tagTypeObject.animal_id
    const inputItem = this.autoCompleteInputTargets[targetIdx];
    const hiddenItem = this.autoCompleteHiddenTargets[targetIdx];
    if (inputItem) inputItem.value = tagNum
    if (hiddenItem) hiddenItem.value = animalId
  }

  startToAdd = () => {
    return new Promise(resolve => {
      setTimeout(() =>
        resolve(this.add(new CustomEvent("add"),true)), 1);
    })
  }

  add(e, initial=false){
    super.add(e)
    this.displayToggleSpecimenHeader()
    if (!initial) this.refreshIndexValue()
    setTimeout(() => this.addIdForFlatpickerHidden(), 500)
  }

  displayToggleSpecimenHeader(){
    const spHeader = document.getElementById('specimen_header')
    if (!spHeader) return
    spHeader.hidden = !this.hasItemTarget
  }

  // we need to put an ID for flatpickr hidden field in order to use the copy-down feature.
  addIdForFlatpickerHidden(){
    const items = document.getElementsByClassName('form-control bootstrap-datepicker form-control input')
    for (let i = 0; i < items.length; i++) {
      const element = items[i];
      element.id = 'collection_date_hidden'
    }
  }

  onInputChange(){
    super.onInputChange()
  }

  getLastTarget(targets){
    return targets[targets.length - 1]
  }

  remove(e){
    const selectedCard = e.target.closest(this.wrapperSelectorValue);
    if (selectedCard.dataset.newRecord === 'true'){ 
      super.remove(e)
      this.refreshIndexValue()
      this.displayToggleSpecimenHeader()
    } else {
      this.deleteSpecimen(e).then(res =>{
        this.displayToggleSpecimenHeader()
      })
    }
  }

  refreshIndexValue(){
    let total = 0 
    for (let i = 0; i < this.childIndexTargets.length; i++) {
      const target = this.childIndexTargets[i];
      target.innerHTML = (i + 1)

      const item = this.itemTargets[i]
      if (item) item.dataset.ordernumber = i + 1
      total += 1
    }

    let specimen_count_info = document.getElementById('specimen_count_info_id')
    if (specimen_count_info) {
      specimen_count_info.innerHTML = i18next.t("You have total_specimen", { count: total } )
    }
    
  }

  duplicate(e){
    this.add(e)

    const currentCard = e.target.closest(this.wrapperSelectorValue);
    let fields = 'textarea, input, select';
    let selectedFields = currentCard.querySelectorAll(fields);
    let addedCardItem = this.getLastTarget(this.specimenCardTargets)
    let newFields = addedCardItem.querySelectorAll(fields);
    let flatPickr = ""
    if (newFields.length != selectedFields.length){
      // We need to create a flatpickr input. After adding flatpickr_alt_input, duplicate process can not find a new input. 
      flatPickr = addedCardItem.getElementsByClassName("input-group date")[0]
      if (flatPickr) flatPickr.appendChild(this.createFlatPickrInput())
      newFields = addedCardItem.querySelectorAll(fields);
    }

    for (let i = 0; i < selectedFields.length; i++) {
      let existsItem = selectedFields[i];
      let newItem = newFields[i];

      if (!existsItem || !newItem){
        continue;
      }

      //  if attributes have not nested fields , we can compare directly without extract brackets
      if (existsItem.id.toString() == newItem.id.toString()){
        newItem.value = existsItem.value
        continue;
      }
      //  We will need to extract name for the fields. For example ,
      // 'accession[animals_attributes][0][specimens_attributes][1689958825769][specimen_type_description_id]'
      //  after regex matching we will get : specimen_type_description_id
      let lastPartOfNameExistsItem = existsItem.name.toString().match(/(?![^\[]*\[)[^\]]+(?=\])/)
      let lastPartOfNameNewItem = newItem.name.toString().match(/(?![^\[]*\[)[^\]]+(?=\])/)

      if (!lastPartOfNameExistsItem || !lastPartOfNameNewItem){
        continue;
      }

      //  We should not to get previous uniqu record id for the new one
      if (lastPartOfNameNewItem[0].toString() == "id"){
        continue;
      }

      if (lastPartOfNameNewItem[0].toString() == lastPartOfNameExistsItem[0].toString()){
        // we need to set a value for the select to iterate specimen_type_description_id options.
        if (lastPartOfNameExistsItem[0].toString() == "specimen_type_description_id"){
          if (existsItem.options){
            this.generateAndLoadOptions(existsItem, newItem)
          }
        }

        newItem.value = existsItem.value
        if (newItem.type == 'radio'){
          newItem.checked = existsItem.checked
        }
      }
    }

    // we need remove temp field from flatPickr element after completed duplicate
    const willRemoved = flatPickr.querySelector("[data='temproray_field']")
    if (willRemoved) willRemoved.remove();

  }
  
  generateAndLoadOptions(source, target){
    let sourceClone = source.cloneNode(true);
    for (let i = 0; i < sourceClone.options.length; i++) {
      let item = sourceClone.options[i]
      if (item.value != ""){
        const option = document.createElement("option");
        option.value = item.value;
        option.innerHTML = item.text
        target.appendChild(option);
      }
    }
  }

  async deleteSpecimen(e){
    LoadingSpinner("show")
    let id = e.currentTarget.dataset.specimenId
    let url = '/specimens/'+ id +'.json'
    return axios({
      url: url, 
      method: 'DELETE',
    })
    .then(res => {
      const r = e.target.closest(this.wrapperSelectorValue);
      r.remove();
      LoadingSpinner("hide")
      this.refreshIndexValue()
      return Promise.resolve(res)
    })
    .catch((error) => {
      LoadingSpinner("hide")
      const msg = i18next.t('An error occurred when deleting the specimen')
      notify({
        message: msg  + " : " + error,
        status: "error"
      });
      return Promise.reject(error)
    });
  }

  displayLoading() {
    this.indicatorAxiosTarget.hidden = false;
  }

  hideLoading() {
    this.indicatorAxiosTarget.hidden = true;
  }

  // <input class="form-control bootstrap-datepicker form-control input" placeholder="Click and select a proper date" required="" tabindex="0" type="text" readonly="readonly"></input>
  createFlatPickrInput(){
    const x = document.createElement("input");
    x.setAttribute("type", "text");
    x.setAttribute("readonly", "readonly");
    x.setAttribute("required", "required");
    x.setAttribute("tabindex", "0");
    x.setAttribute("class", "form-control bootstrap-datepicker form-control input");
    x.setAttribute("placeholder", i18next.t("Click and select a proper date"));
    x.setAttribute("data", "temproray_field");
    x.hidden = true
    return x
  }


  isSingleAnimal(){
    return this.amountOfSubmissionTypeValue === "single"
  }

  isMultipleAnimal(){
    return this.amountOfSubmissionTypeValue === "multiple"
  }
  
  figureOutAmountOfSubmissionType(){
    if (this.setupAnimalCountValue == 1){
      this.amountOfSubmissionTypeValue = "single"

    } else if (this.setupAnimalCountValue > 1){
      this.amountOfSubmissionTypeValue = "multiple"

    } else if (this.animalsDbRecordSizeValue == 1){
      this.amountOfSubmissionTypeValue = "single"

    } else if (this.animalsDbRecordSizeValue > 1){
      this.amountOfSubmissionTypeValue = "multiple"
    }
  }

  initialSetAnimalTagsParams(){
    if (this.initialAnimalTagTypesNumValue){
      this.initialAnimalTagTypesNumsListValue = JSON.parse(this.initialAnimalTagTypesNumValue)
    }
    if (this.needGenerateAnimalIds){
      this.needGenerateAnimalIdsListValue = JSON.parse(this.needGenerateAnimalIdsListValue)
    }
  }

  addSetupIncrementalNameByOneBy(){
    const increment = this.setupIncrementalNameValue
    if (!increment) return
    for (let i = 0; i < this.nameTargets.length; i++) {
      const lastItem =  this.nameTargets[i];
      if (lastItem) lastItem.value = increment + "-" + (i + 1)
    }
  }

}

function refreshSpecimenTypeDesc(currentOrderNumber, data){
  const belowItems =  Array.from(document.querySelectorAll(itemSelector)).filter(el => Number(el.dataset.ordernumber) > currentOrderNumber)
    for (let i = 0; i < belowItems.length; i++) {
      const pickedItem = belowItems[i];
      const target = pickedItem.querySelector(specimenTypeDescSelector)
      if (target) target.innerHTML = "";
      generateOptionForSpecimenTypeDesc(data, target)
    }
}

function generateOptionForSpecimenTypeDesc(data, target){
   // Add a empty option
   const option = document.createElement("option");
   option.value = "";
   option.innerHTML = ""
   if (target) target.appendChild(option);
   data.forEach((item) => {
     const option = document.createElement("option");
     option.value = item.id;
     option.innerHTML = item.value
     target.appendChild(option);
   });
}

